import React from 'react';
import { Link } from 'react-router-dom';
import { FaSpinner, FaExclamationTriangle, FaShoppingBag } from 'react-icons/fa';

/** Stanja učitavanja, greške i praznog rezultata — isti vizuelni jezik na svim shop stranicama. */

export const LoadingState = ({ label = 'Učitavanje…' }) => (
  <div className="py-24 text-center" data-testid="shop-loading">
    <FaSpinner className="w-8 h-8 mx-auto mb-4 text-brand-accent animate-spin" />
    <p className="text-neutral-500">{label}</p>
  </div>
);

export const ErrorState = ({ message = 'Došlo je do greške pri učitavanju.', onRetry }) => (
  <div className="py-24 text-center" data-testid="shop-error">
    <FaExclamationTriangle className="w-8 h-8 mx-auto mb-4 text-error" />
    <p className="text-neutral-700 mb-6">{message}</p>
    {onRetry && (
      <button type="button" onClick={onRetry} className="btn-secondary">
        Pokušajte ponovo
      </button>
    )}
  </div>
);

export const EmptyState = ({
  title = 'Trenutno nema proizvoda',
  description = 'Uskoro dodajemo nove artikle. Do tada nas slobodno kontaktirajte.',
  actionTo = '/kontakt',
  actionLabel = 'Kontaktirajte nas',
}) => (
  <div className="py-24 text-center" data-testid="shop-empty">
    <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-brand-bgSoft flex items-center justify-center">
      <FaShoppingBag className="w-6 h-6 text-brand-accent" />
    </div>
    <h2 className="font-heading text-2xl text-brand-primary mb-3">{title}</h2>
    <p className="text-neutral-500 mb-8 max-w-md mx-auto">{description}</p>
    {actionTo && (
      <Link to={actionTo} className="btn-accent inline-block">
        {actionLabel}
      </Link>
    )}
  </div>
);

export default { LoadingState, ErrorState, EmptyState };
